import { render, staticRenderFns } from "./product-showcase-fizzler.vue?vue&type=template&id=64fe7ca0&scoped=true&"
import script from "./product-showcase-fizzler.vue?vue&type=script&lang=js&"
export * from "./product-showcase-fizzler.vue?vue&type=script&lang=js&"
import style0 from "./product-showcase-fizzler.vue?vue&type=style&index=0&id=64fe7ca0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fe7ca0",
  null
  
)

export default component.exports